import styled from "styled-components";

export const Link = styled.a.attrs(props => ({ className: props.className}))`
    color: ${ props => props.light ? '#FFFFFF' : props.theme.primary};
    text-decoration: none;
    font-weight: bold;
`
